export default "__VITE_ASSET__BL0MX2uI__"